import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import CloneableInputGroup from 'library/components/cloneable-input-group';
import { InputEvent as SyntheticEvent } from 'library/helpers/synthetic-events';
import Toggle from 'library/components/form-elements/toggle';
import Tag from 'library/components/tag';

const LangaugesFields = ({ className='', data, onChange, baseKey = '', index, active=false }) => {
    const remove = () => {
        onChange(new SyntheticEvent({
            name: baseKey,
            value: undefined,
            type: 'object'
        }));
    }

    return (
        <div className={className}>
            <label>
                Language
                <input placeholder="Language" type="text" onChange={onChange} value={resolve(data, 'name', '')} name={`${baseKey}.name`} disabled={!active} required={active} />
            </label>
            <label>
                Proficiency
                <select onChange={onChange} name={`${baseKey}.proficiency`} value={resolve(data, 'proficiency', '')} disabled={!active} required={active}>
                    <option value="">-</option>
                    <option value="5">Native or bilingual proficiency</option>
                    <option value="4">Full professional proficiency</option>
                    <option value="3">Professional working proficiency</option>
                    <option value="2">Limited working proficiency</option>
                    <option value="1">Elementary proficiency</option>
                </select>
            </label>
            <div className="resume-builder-fields-controls">
                <span className="a" onClick={() => remove()}>remove</span>
            </div>
        </div>
    )
}

const Languages = ({ data, handleChange }) => {
    const hasLanguages = resolve(data, 'has_languages', false, '.');

    const onChange = () => {
        handleChange(new SyntheticEvent({
            name: 'has_languages',
            value: !hasLanguages
        }));
    }

    const fieldsClass = [
        "resume-builder-fields",
        !hasLanguages ? 'resume-builder-fields-disabled' : null
    ].filter(c=>c).join(' ')

    return (
        <section className={!hasLanguages ? 'resume-builder-multi-disabled' : ''}>
            <h1><Toggle name="has_languages" checked={hasLanguages} onChange={onChange} /> Languages <Tag className="tag-auxilary-4">Suggested for Resume Creation</Tag></h1>
            <p>Do you speak multiple languages? </p>
            <CloneableInputGroup disabled={!hasLanguages} onChange={handleChange} values={data} dataKey="languages" className="resume-builder-multi">
                <LangaugesFields className={fieldsClass} active={hasLanguages} onChange={handleChange} />
            </CloneableInputGroup>
        </section>
    )
}


export default Languages;
